module.exports = __webpack_public_path__ + "img/price-banner-xs.ec5346b0.jpg";